import { FIRST_PAGE } from 'data/global';
import useQueryParams from 'hooks/useQueryParams';
import { useEffect } from 'react';
import { Params } from 'react-router-dom';

export default function useResetPage(totalPages: number, currentPage: string) {
  const { setQueryParam } = useQueryParams<Params>();

  useEffect(() => {
    if ((totalPages && +currentPage > totalPages) || +currentPage < 1) {
      setQueryParam('page', FIRST_PAGE);
    }
  }, [totalPages, currentPage, setQueryParam]);
}
